import React from 'react';

const Process = () => (
  <div id="competitive-intelligence" className="w-screen bg-indigo-50/50 py-20 sm:pb-[100px] border-t scroll-mt-28">
    <div className="content max-w-[1120px] mx-auto">
      <h4 className="hidden md:flex text-indigo-600 font-semibold sm:text-lg">AI-native intelligence</h4>
      <div className="flex flex-col gap-4 mt-8 -ml-1">
        <h3
          data-british="AI-Powered data cleaning, insights, and optimisation guide report
          generation"
          className="text-4xl sm:text-6xl font-bold tracking-tighter"
        >
          AI-Powered data cleaning, insights, and optimization guide report generation
        </h3>
        <div className="w-full pt-10 fade-up">
          <img src="/images/process.png" alt="Sophare Process" className="w-full" />
        </div>
      </div>
    </div>
  </div>
);

export default Process;
